<template>
  <AppSidebar
    v-model="navigationDrawerSubscription"
    :mini="mini"
    class="SubscriptionSidebar-drawer"
  >
    <div v-if="subscription" class="app-sidebar-menu app-sidebar-menu--sections">
      <section v-if="organizationItems.length" class="app-sidebar-menu__section">
        <h2 v-if="!mini" class="SubscriptionSidebar-section__title">
          {{ $t(`${TRANSLATION_KEY_PREFIX}.organization`) }}
        </h2>
        <div class="app-sidebar-menu__items">
          <AppSidebarItem
            v-for="item in organizationItems"
            :key="item.key"
            :item="item"
            :icon-only="mini"
            @select="goTo"
          />
        </div>
      </section>

      <section v-if="projectItems.length" class="app-sidebar-menu__section">
        <h2 v-if="!mini" class="SubscriptionSidebar-section__title">
          {{ $t(`${TRANSLATION_KEY_PREFIX}.projectsSection`) }}
        </h2>
        <div class="app-sidebar-menu__items">
          <AppSidebarItem
            v-for="item in projectItems"
            :key="item.key"
            :item="item"
            :icon-only="mini"
            @select="goTo"
          />
        </div>
      </section>
    </div>
  </AppSidebar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import AppSidebar from '@/common/app-sidebar/AppSidebar.vue'
import AppSidebarItem from '@/common/app-sidebar/AppSidebarItem.vue'
import {
  SUBSCRIPTION_CONSUMPTION_ROUTE_NAME,
  SUBSCRIPTION_BILLING_ROUTE_NAME,
  SUBSCRIPTION_SUBSCRIBERS_ROUTE_NAME,
  SUBSCRIPTION_TEAMS_ROUTE_NAME,
  SUBSCRIPTION_PROJECTS_ROUTE_NAME,
  SUBSCRIPTION_CLOSED_PROJECTS_ROUTE_NAME,
  SUBSCRIPTION_SIGNATURES_CONSUMPTION_ROUTE_NAME,
} from '@/router/routerData'
import { GlobalMutationTypes } from '@/store/modules/global/mutation_types'

const TRANSLATION_KEY_PREFIX = 'subscriptions.SubscriptionSidebar'

export default {
  name: 'SubscriptionSidebar',
  components: { AppSidebar, AppSidebarItem },
  data () {
    return {
      TRANSLATION_KEY_PREFIX,
      menu: [
        {
          text: this.$t(`${TRANSLATION_KEY_PREFIX}.consumption`),
          value: 'consumption',
          icon: 'dashboard',
          to: SUBSCRIPTION_CONSUMPTION_ROUTE_NAME,
          adminOnly: true,
          billingOnly: true,
        },
        {
          text: this.$t(`${TRANSLATION_KEY_PREFIX}.signatureConsumption`),
          value: 'signatureConsumption',
          icon: 'signature',
          to: SUBSCRIPTION_SIGNATURES_CONSUMPTION_ROUTE_NAME,
          adminOnly: true,
          billingOnly: true,
        },
        {
          text: this.$t(`${TRANSLATION_KEY_PREFIX}.billing`),
          value: 'billing',
          icon: 'receipt',
          to: SUBSCRIPTION_BILLING_ROUTE_NAME,
          billingOnly: true,
        },
        {
          text: this.$t(`${TRANSLATION_KEY_PREFIX}.subscribers`),
          value: 'subscribers',
          icon: 'person',
          to: SUBSCRIPTION_SUBSCRIBERS_ROUTE_NAME,
        },
        {
          text: this.$t(`${TRANSLATION_KEY_PREFIX}.teams`),
          value: 'teams',
          icon: 'group',
          to: SUBSCRIPTION_TEAMS_ROUTE_NAME,
          adminOnly: true,
        },
        {
          text: this.$t(`${TRANSLATION_KEY_PREFIX}.projects`),
          value: 'projects',
          icon: 'home_storage',
          to: SUBSCRIPTION_PROJECTS_ROUTE_NAME,
        },
        {
          text: this.$t(`${TRANSLATION_KEY_PREFIX}.closedProjects`),
          value: 'closedProjects',
          icon: 'home_storage',
          to: SUBSCRIPTION_CLOSED_PROJECTS_ROUTE_NAME,
        },
      ],
    }
  },
  computed: {
    ...mapState('global', ['mini']),
    ...mapState('user', ['profile']),
    ...mapState('subscription', ['subscription']),
    ...mapGetters('subscription', ['hasDataroomStoragePlan', 'hasSubscriptionEnvelopesPacks']),
    navigationDrawerSubscription: {
      get () {
        return !this.$vuetify.display.mobile
          ? true
          : this.$store.state.global.navigationDrawerProfile
      },
      set (newValue) {
        if (!this.$vuetify.display.mobile) return
        this.$store.commit(`global/${GlobalMutationTypes.SET_NAVIGATION_DRAWER_PROFILE}`, newValue)
      },
    },
    subscriptionSidebarItems () {
      let menu = this.menu
      if (!this.canAccessConsumption) {
        menu = this.menu.filter(item => item.value !== 'consumption')
      }

      if (this.profile.isSubAdmin) {
        return menu
      }
      if (this.profile.isSubBillingAdmin) {
        return menu.filter(item => item.billingOnly)
      }
      return menu.filter(item => !item.adminOnly)
    },
    canAccessConsumption () {
      return this.hasDataroomStoragePlan || this.hasSubscriptionEnvelopesPacks
    },
    sidebarItems () {
      return this.subscriptionSidebarItems.map(item => ({
        key: item.to,
        label: item.text,
        icon: item.icon,
        kind: 'nav',
        active: this.$route.name === item.to,
        dataLocator: `subscription-${item.value}-nav-item`,
      }))
    },
    organizationItems () {
      return this.sidebarItems.filter(item => [
        SUBSCRIPTION_SIGNATURES_CONSUMPTION_ROUTE_NAME,
        SUBSCRIPTION_CONSUMPTION_ROUTE_NAME,
        SUBSCRIPTION_BILLING_ROUTE_NAME,
        SUBSCRIPTION_SUBSCRIBERS_ROUTE_NAME,
        SUBSCRIPTION_TEAMS_ROUTE_NAME,
      ].includes(item.key))
    },
    projectItems () {
      return this.sidebarItems.filter(item => [
        SUBSCRIPTION_PROJECTS_ROUTE_NAME,
        SUBSCRIPTION_CLOSED_PROJECTS_ROUTE_NAME,
      ].includes(item.key))
    },
  },
  methods: {
    goTo (route) {
      if (this.$route.name !== route) {
        this.$router.push({ name: route })
      }
      this.navigationDrawerSubscription = false
    },
  },
}
</script>

<style scoped lang="scss">
.SubscriptionSidebar-section__title {
  margin: 0;
  padding: 0 12px;
  color: #5E7997;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}
</style>
